import {
  IsNotEmpty,
  IsOptional,
  IsNumber,
  IsString,
  ValidateNested,
  IsBoolean,
} from 'class-validator';

// import { IAdyenPaymentRequest, IBillingData } from 'payment-library/providers/AdyenGateway/types';

import {
  CardType,
  getCardType,
} from 'business-layer/helpers/creditCards';


export interface IBillingData {

}
export interface IAdyenPaymentRequest {
  payByLinkId: string;
  cardholderName: string;
  cardNumber: string;
  cvv: number;
  expMonth: number;
  expYear: number;
  creditCardType: string;
  //TODO:
  firstName: string;
  lastName: string;
  //TODO:
  billing: IBillingData;
}


export class BillingDataDto implements IBillingData {}

export class PaymentRequestDto implements Partial<IAdyenPaymentRequest> {
  constructor(obj: any) {
    Object.defineProperties(this, {
      cardholder: { writable: true, enumerable: false },
      exp: { writable: true, enumerable: false },
      cardholderName: {
        get: function () { return this.cardholder; },
        enumerable: true
      },
      expMonth: {
        get: function () { return +this.exp.split('/')[0]?.trim() || 0; },
        enumerable: true
      },
      expYear: {
        get: function () { return 2000 + +this.exp.split('/')[1]?.trim() || 0; },
        enumerable: true
      },
      creditCardType: {
        get: function () {
          const cardType: CardType | undefined = getCardType(this.cardNumber.replace(/\D/g,''));
          return  cardType?.type || 'default';
        },
        enumerable: true
      },
    });

    Object.assign(this, obj);
  }

  @IsNotEmpty()
  @IsString()
  payByLinkId: string;

  @IsNotEmpty()
  @IsString()
  cardholder: string;

  @IsNotEmpty()
  @IsString()
  cardNumber: string;

  @IsOptional()
  @IsNumber()
  cvv: number;

  @IsNotEmpty()
  @IsString()
  exp: string;

  @IsNotEmpty()
  @IsString()
  firstName: string;

  @IsNotEmpty()
  @IsString()
  lastName: string;

  @IsNotEmpty()
  @IsBoolean()
  toc: boolean;

  //TODO:
  @IsOptional()
  @ValidateNested()
  billing: BillingDataDto;
}
